// React
import React from "react";
import PropTypes from "prop-types";
// Framework
import { classnames } from "ui/classnames";
import { makeStyles, TableCell } from "ui/components";
import { PiDotsThreeVerticalDuotone as DragHandleIcon } from "@mefisto/icon";

////////////////////////////////////////////////////
/// Styles
////////////////////////////////////////////////////

const useStyles = makeStyles((theme) => ({
  root: {
    color: theme.palette.action.active,
    border: theme.palette.border.surface.main,
    borderColor: "transparent",
    borderLeft: "none",
    borderRight: "none",
    backgroundColor: theme.palette.background.surface.main,
    minWidth: 48,
    // A small trick to size the cell based on the content
    position: "sticky",
    width: 1,
    left: 0,
    zIndex: 1,
    whiteSpace: "nowrap",
    cursor: "grab",
  },
  content: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  dragged: {
    cursor: "grabbing",
  },
  highlighted: {
    borderColor: theme.palette.border.surface.color,
  },
  transparent: {
    backgroundColor: "transparent",
  },
  hidden: {
    visibility: "hidden",
  },
}));

////////////////////////////////////////////////////
/// Component
////////////////////////////////////////////////////

const TableRowDragHandle = ({
  highlighted,
  attributes,
  listeners,
  isDragging,
}) => {
  // Styles
  const classes = useStyles();
  // Render
  return (
    <TableCell
      padding="checkbox"
      className={classnames(classes.root, {
        [classes.transparent]: !highlighted,
        [classes.highlighted]: highlighted,
        [classes.dragged]: isDragging,
      })}
      {...attributes}
      {...listeners}
    >
      <div className={classes.content}>
        <DragHandleIcon
          className={classnames({
            [classes.hidden]: !highlighted,
          })}
        />
      </div>
    </TableCell>
  );
};

TableRowDragHandle.propTypes = {
  highlighted: PropTypes.bool,
};

export default TableRowDragHandle;
